const DEFAULT_TIMEOUT_MS = 5000;

export const getCurrentLocation = (timeout = DEFAULT_TIMEOUT_MS) =>
  new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => resolve({ lat: position.coords.latitude, lng: position.coords.longitude }),
      () => resolve(null),
      { timeout, maximumAge: 60000 }
    );
  });
